module.exports = __webpack_public_path__ + "img/Columba.28e48711.png";